
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_storecustomisation';
const tableOfContents = [{
  "title": "------",
  "slug": "",
  "children": [{
    "title": "Branding",
    "slug": "branding",
    "children": []
  }, {
    "title": "Pages",
    "slug": "pages",
    "children": []
  }]
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <_Heading level={2} id={""} nextElement={{
      "type": "paragraph"
    }}>------</_Heading>
    <p>{`For a start, get started with a simple one, so you can focus on important aspects of the business. `}</p>
    <_Heading level={3} id={"branding"} nextElement={{
      "type": "paragraph"
    }}>Branding</_Heading>
    <p>{`Add your branding (Set your colours, typography, and other theme settings)`}</p>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/customisation-store.png" />
    </div>
    <_Heading level={3} id={"pages"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Pages</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Business crucial pages like about us, FAQ, Privacy, Terms, contact us page, etc can be created`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
